'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
/** 
 * @desc {Object} 钩子工具类
 */

var Promise = require('es6-promise').Promise;

// 获取随机字符串
var getRandomString = function getRandomString() {
    var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 4;

    var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz';
    var maxPos = $chars.length;
    var pwd = '';
    for (var i = 0; i < len; i += 1) {
        pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
    }
    return pwd + '-';
};

var str = getRandomString();
var j = 0;

var beforeList = []; // 预执行的钩子列表
var afterList = []; // 后执行的钩子列表
// 获取预执行钩子回调数据
var getBeforeSendParams = function getBeforeSendParams(params, requestType) {
    var idNo = str + j;
    j += 1;
    return {
        idNo: idNo,
        requestType: requestType,
        params: params
    };
};
// 获取后执行钩子回调数据
var afterBeforeSendHook = function afterBeforeSendHook(data) {
    for (var i = 0; i < afterList.length; i += 1) {
        afterList[i](data);
    }
};

exports.default = {
    register: function register(type, cb) {
        // 给对应列表注入函数
        if (type === 'before') {
            return beforeList.push(cb);
        }
        return afterList.push(cb);
    },
    beforeSendHook: function beforeSendHook(obj) {
        obj.hookData = getBeforeSendParams(obj.hookData, obj.requestType);
        obj.target.idNo = obj.hookData.idNo;
        if (beforeList.length === 0) {
            return obj.netRequest.call(obj.target, obj.params).then(function (data) {
                afterBeforeSendHook(data);
                return data.json;
            }, function (err) {
                afterBeforeSendHook(err);
                return err.err;
            });
        }

        return new Promise(function (resolve, reject) {
            function doNext(i) {
                beforeList[i](obj.hookData, function () {
                    i += 1;
                    if (beforeList.length > i) {
                        doNext(i);
                    } else {
                        obj.netRequest.call(obj.target, obj.params).then(function (data) {
                            resolve(data.json);
                            afterBeforeSendHook(data);
                        }, function (err) {
                            reject(err.err);
                            afterBeforeSendHook(err);
                        });
                    }
                });
            }

            doNext(0);
        });
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@souche-vue/vue-burying/node_modules/@souche-f2e/http-request/dist/utils/hooks.js
// module id = /4C/
// module chunks = 11